import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { Seller } from '@/types/Seller';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';

type Props = {
    seller: Seller;
    showSendSellerMessageModal: Function;
};

const DeclineMessage = ({ seller, showSendSellerMessageModal }: Props) => {
    return (
        <FormattedMessage
            id="registration.declined_format"
            values={{
                houseName: seller.name,
                link: (
                    <ShouldLogInContainer requireCompleteProfile requireLogin runFunction={showSendSellerMessageModal}>
                        <Link>
                            <FormattedMessage id="send_message" />
                        </Link>
                    </ShouldLogInContainer>
                ),
            }}
        />
    );
};

export default React.memo<Props>(DeclineMessage, isEqual);
